// Release metadata loaded from runtime config.json
// This file provides access to build/release information injected during deployment

export interface ReleaseMetadata {
  version: string;
  sha: string;
  manifest: string;
  built_at: string;
  environment: string;
}

let releaseMetadata: ReleaseMetadata | null = null;

/**
 * Load release metadata from /config.json
 * This file is generated during deployment and contains build-time information
 */
export async function loadReleaseMetadata(): Promise<ReleaseMetadata> {
  if (releaseMetadata) {
    return releaseMetadata;
  }

  try {
    const response = await fetch("/config.json");
    if (!response.ok) {
      throw new Error(`Failed to load config.json: ${response.status}`);
    }

    const config = await response.json();
    releaseMetadata = config.release as ReleaseMetadata;

    console.info("[Release] Loaded release metadata:", releaseMetadata);
    return releaseMetadata as ReleaseMetadata;
  } catch (error) {
    console.warn(
      "[Release] Failed to load release metadata, using defaults:",
      error,
    );

    // Fallback for local development
    releaseMetadata = {
      version: "dev",
      sha: "local",
      manifest: "local-build",
      built_at: new Date().toISOString(),
      environment: "local",
    };

    return releaseMetadata;
  }
}

/**
 * Get the current release metadata
 * Must call loadReleaseMetadata() first during app initialization
 */
export function getReleaseMetadata(): ReleaseMetadata {
  if (!releaseMetadata) {
    throw new Error(
      "Release metadata not loaded. Call loadReleaseMetadata() during app initialization.",
    );
  }
  return releaseMetadata;
}

/**
 * Get release metadata synchronously (returns null if not loaded)
 */
export function getReleaseMetadataSync(): ReleaseMetadata | null {
  return releaseMetadata;
}
